module.exports = __webpack_public_path__ + "img/img-116.3adda1e2.png";